import { useContext, useState, useEffect } from "react";
import { useFetchApplications } from "./useFetchApplications";
import { ApplicationCard } from "..";
import { ApplicationParamsContext } from "./ApplicationContextWrapper";
import { DispatchErrorContext } from "../../../context/ErrorContext";
import { StyledNoneApplications } from "./style";
import { useTranslation } from "react-i18next";

const byNewest = (a, b) => new Date(b.createdAt) - new Date(a.createdAt);

const sortApplications = (applications = []) => {
  const invited = applications.filter((app) => app.status === "invited").sort(byNewest);
  const rest = applications.filter((app) => app.status !== "invited").sort(byNewest);
  return [...invited, ...rest];
};

const ApplicationList = ({
  useIndex, // Change active application when clicking on application card
  id,
}) => {
  const { t } = useTranslation();
  const dispatchError = useContext(DispatchErrorContext);
  const { state, dispatch } = useContext(ApplicationParamsContext); // Params
  const { error, data, status } = useFetchApplications({ ...state.params });

  // ALL APPLICATIONS FROM REACT QUERY FLATTENED TO A SINGLE ARRAY
  const [flattenedList, setFlattenedList] = useState([]);

  // SEND LIST TO CONTEXT
  useEffect(() => {
    if (status === "success" && data?.pages) {
      const sorted = sortApplications(data?.pages?.flatMap((page) => page?.data));

      dispatch({
        type: "update_list",
        payload: sorted,
      });
      setFlattenedList(sorted);
    } else {
      setFlattenedList([]);
    }
  }, [data, status, dispatch]);

  useEffect(() => {
    if (error) {
      dispatchError({ type: "set_error", payload: error.message });
    }
  }, [error, dispatchError]);

  return (
    <>
      {status === "success" && data ? (
        <>
          {flattenedList.length === 0 ? (
            <StyledNoneApplications>
              <h3>{t("component.list.no_applications_found", "No applications found")}</h3>
            </StyledNoneApplications>
          ) : (
            flattenedList.map((app) => (
              <ApplicationCard
                key={app.id}
                useIndex={useIndex}
                application={app}
                onClick={() => {
                  dispatch({
                    type: "set_index",
                    payload: app.id,
                  });
                }}
              />
            ))
          )}
        </>
      ) : null}
    </>
  );
};

export default ApplicationList;
